import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatSort, MatSortModule, MatTableDataSource, MatTabChangeEvent } from '@angular/material';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';

import { MainserviceService } from 'src/app/shared/service/mainservice.service';

import { HttpClient } from '@angular/common/http';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';


interface City1 {
  value: string;
  viewValue5: string;

}
interface State1 {
  value: string;
  viewValue4: string;

}
interface Role1 {
  value: string;
  viewValue7: string;

}
interface City2 {
  value: string;
  viewValue10: string;

}
interface State2 {
  value: string;
  viewValue8: string;

}
interface Role2 {
  value: string;
  viewValue14: string;

}

@Component({
  selector: 'app-donor',
  templateUrl: './donor.component.html',
  styleUrls: ['./donor.component.scss']
})

export class DonorComponent implements OnInit {

  posturl: string ="assets/pdf/";

  city1: City1[] = [
    {value: 'Hyderbad', viewValue5: 'Hyderbad'},
    {value: 'Banglore', viewValue5: 'Bangalore'},

  ];
  state1: State1[] = [
    {value: 'Andrapradesh', viewValue4: 'Andrapradesh'},
    {value: 'Karnataka', viewValue4: 'Karnataka'},

  ];
  role1: Role1[] = [
    {value: 'LCA', viewValue7: 'LCA engineer'},
    {value: 'LCA', viewValue7: 'LCA lead'},

  ];
  city2: City2[] = [
    {value: 'Hyderbad', viewValue10: 'Hyderbad'},
    {value: 'Banglore', viewValue10: 'Bangalore'},

  ];
  state2: State2[] = [
    {value: 'Andrapradesh', viewValue8: 'Andrapradesh'},
    {value: 'Karnataka', viewValue8: 'Karnataka'},

  ];
  role2: Role2[] = [
    {value: 'LCA', viewValue14: 'LCA engineer'},
    {value: 'LCA', viewValue14: 'LCA lead'},

  ];

  result = [{name: "3"}, {name: "4"}, {name: "5"},{name: "6"}, {name: "7"}, {name: "8"},{name: "9"}, {name: "10"}, {name: "11"}];

  showtable:boolean=true;
  hidetable: boolean=false;
  archivedtable: boolean=false;
  hidearchivedtable: boolean=false;

  // selectedTabIndex: any;

  // name: any;
  // animal: any;
  @Output() backEvent = new EventEmitter<string>();
  constructor(public dialog: MatDialog,
    private router:Router, 
    private MainserviceService: MainserviceService,
    private HttpClient:HttpClient,
    private httpService: HttpClient) { }
    
    txtpostdate = new FormControl();
    txtlcanum = new FormControl();
    txtlcayear = new FormControl();
    selState = new FormControl();
    selCity = new FormControl();
    selRole = new FormControl();

    txtpostdateA = new FormControl();
    txtlcanumA = new FormControl();
    txtlcayearA = new FormControl();
    selStateA = new FormControl();
    selCityA = new FormControl();
    selRoleA = new FormControl();

    ngOnInit() {    
      
      window.scroll({behavior: 'smooth',left: 0,top: 0});
        this.clearDataA();
        this.clearData();
        this.getstatename();
        this.getposition();
    }

  //statelist = [];
  statelist :any;
  // cities: string [];
  cities:any;   
  citiesarchive:any;  
  filteredcities: any;
  filteredcitiesarchive: any;
  positionlist:any;
  positionlistarchive:any;

  ResetData()
  {
    this.clearDataA();    
    this.clearData();
    this.getstatename();
    this.getposition();    
  }

  postingsearch(){
    

    var PostDate = moment(this.txtpostdate.value).format("MM/DD/YYYY");

    if(PostDate == "Invalid date")
      this.MainserviceService.postDate = "";
    else
      this.MainserviceService.postDate = PostDate;

    if(this.txtlcanum.value == null)
      this.MainserviceService.lcaNumber = "";
    else
      this.MainserviceService.lcaNumber = this.txtlcanum.value;

    if(this.txtlcayear.value == null)
      this.MainserviceService.lcaYear = "";
    else
      this.MainserviceService.lcaYear = this.txtlcayear.value;

    if(this.selectState == undefined)
      this.MainserviceService.state = "";
    else
      this.MainserviceService.state = this.selectState;

    if(this.selectCity == undefined)
      this.MainserviceService.city = "";
    else
      this.MainserviceService.city = this.selectCity;

    if(this.selectRole == undefined)
      this.MainserviceService.lcaRole = "";
    else
      this.MainserviceService.lcaRole = this.selectRole;

    this.showtable= false;
    this.hidetable= true;
    this.archivedtable = false;
    this.hidearchivedtable=false;


    if((this.MainserviceService.lcaNumber != "0" && this.MainserviceService.lcaNumber != "") && (this.MainserviceService.postDate == "" && this.MainserviceService.lcaYear == "" && this.MainserviceService.state =="" && this.MainserviceService.city == "" && this.MainserviceService.lcaRole ==""))
    {
      this.getpostingdata1(this.MainserviceService.lcaNumber);
    }
    else if((this.MainserviceService.postDate != "" && this.MainserviceService.postDate !="Invalid date") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.lcaYear == "" && this.MainserviceService.state =="" && this.MainserviceService.city == "" && this.MainserviceService.lcaRole ==""))
    {
      this.getpostingdata2(this.MainserviceService.postDate);
    }    
    else if((this.MainserviceService.state != "" && this.MainserviceService.state != null) && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.lcaYear == "" && this.MainserviceService.postDate =="" && this.MainserviceService.city == "" && this.MainserviceService.lcaRole ==""))
    {
      this.getpostingdata3(this.MainserviceService.state);
    }    
    else if((this.MainserviceService.state != ""  && this.MainserviceService.city != "" ) && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.postDate =="" && this.MainserviceService.lcaYear == "" && this.MainserviceService.lcaRole == ""))
    {
      this.getpostingdata4(this.MainserviceService.state, this.MainserviceService.city);
    }
    else if(this.MainserviceService.lcaRole != "" && (this.MainserviceService.lcaNumber =="" && this.MainserviceService.postDate == "" && this.MainserviceService.lcaYear == "" && this.MainserviceService.state =="" && this.MainserviceService.city == ""))
    {
      this.getpostingdata5(this.MainserviceService.lcaRole);
    }
    else if(this.MainserviceService.lcaYear != "" && (this.MainserviceService.lcaNumber =="" && this.MainserviceService.postDate == "" && this.MainserviceService.lcaRole == "" && this.MainserviceService.state =="" && this.MainserviceService.city == ""))
    {
      this.getpostingdata6(this.MainserviceService.lcaYear);
    }   
    else if(this.MainserviceService.lcaNumber !="" && this.MainserviceService.postDate != "" && this.MainserviceService.lcaRole != "" && this.MainserviceService.state !="" && this.MainserviceService.city != "" && this.MainserviceService.lcaYear != "")
    {
      this.getpostingdata7(this.MainserviceService.lcaNumber,this.MainserviceService.postDate,this.MainserviceService.lcaYear,this.MainserviceService.state,this.MainserviceService.city,this.MainserviceService.lcaRole);
    }
    else if((this.MainserviceService.state != "" && this.MainserviceService.city != "" && this.MainserviceService.lcaRole != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.postDate =="" && this.MainserviceService.lcaYear == ""))
    {
      this.getpostingdata8(this.MainserviceService.state, this.MainserviceService.city,this.MainserviceService.lcaRole);
    }    
    else if((this.MainserviceService.postDate != "" && this.MainserviceService.lcaNumber != "") && (this.MainserviceService.lcaYear == "" && this.MainserviceService.state == "" && this.MainserviceService.city =="" && this.MainserviceService.lcaRole == ""))
    {
      this.getpostingdata9(this.MainserviceService.postDate, this.MainserviceService.lcaNumber);
    }   
    else if((this.MainserviceService.postDate != "" && this.MainserviceService.lcaYear != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.state == "" && this.MainserviceService.city =="" && this.MainserviceService.lcaRole == ""))
    {
      this.getpostingdata10(this.MainserviceService.postDate, this.MainserviceService.lcaYear);
    }   
    else if((this.MainserviceService.postDate != "" && this.MainserviceService.lcaRole != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.lcaYear == "" && this.MainserviceService.state == "" && this.MainserviceService.city ==""))
    {
      this.getpostingdata11(this.MainserviceService.postDate, this.MainserviceService.lcaRole);
    }     
    else if((this.MainserviceService.postDate != "" && this.MainserviceService.state != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.lcaYear == "" && this.MainserviceService.lcaRole == "" && this.MainserviceService.city ==""))
    {
      this.getpostingdata12(this.MainserviceService.postDate, this.MainserviceService.state);
    }       
    else if((this.MainserviceService.postDate != "" && this.MainserviceService.state != "" && this.MainserviceService.city !="") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.lcaYear == "" && this.MainserviceService.lcaRole == ""))
    {
      this.getpostingdata13(this.MainserviceService.postDate, this.MainserviceService.state, this.MainserviceService.city);
    }       
    else if((this.MainserviceService.postDate != "" && this.MainserviceService.state != "" && this.MainserviceService.city !="" && this.MainserviceService.lcaRole != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.lcaYear == ""))
    {
      this.getpostingdata14(this.MainserviceService.postDate, this.MainserviceService.state, this.MainserviceService.city, this.MainserviceService.lcaRole);
    }                
    else if((this.MainserviceService.postDate != "" && this.MainserviceService.lcaYear != "" && this.MainserviceService.state != "" && this.MainserviceService.city !="" && this.MainserviceService.lcaRole != "") && (this.MainserviceService.lcaNumber == ""))
    {
      this.getpostingdata15(this.MainserviceService.postDate, this.MainserviceService.lcaYear, this.MainserviceService.state, this.MainserviceService.city, this.MainserviceService.lcaRole);
    }   
    else if((this.MainserviceService.postDate != "" && this.MainserviceService.lcaYear != "" && this.MainserviceService.state != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.city =="" && this.MainserviceService.lcaRole == ""))
    {
      this.getpostingdata16(this.MainserviceService.postDate, this.MainserviceService.lcaYear, this.MainserviceService.state);
    }   
    else if((this.MainserviceService.postDate != "" && this.MainserviceService.lcaYear != "" && this.MainserviceService.state != "" && this.MainserviceService.city !="") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.lcaRole == ""))
    {
      this.getpostingdata17(this.MainserviceService.postDate, this.MainserviceService.lcaYear, this.MainserviceService.state, this.MainserviceService.city);
    }   
    else if((this.MainserviceService.postDate != "" && this.MainserviceService.lcaYear != "" && this.MainserviceService.lcaRole != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.state == "" && this.MainserviceService.city ==""))
    {
      this.getpostingdata18(this.MainserviceService.postDate, this.MainserviceService.lcaYear, this.MainserviceService.lcaRole);
    }               
    else if((this.MainserviceService.lcaYear != "" && this.MainserviceService.state != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.postDate == "" && this.MainserviceService.city =="" && this.MainserviceService.lcaRole == ""))
    {
      this.getpostingdata19(this.MainserviceService.lcaYear, this.MainserviceService.state);
    }  
    else if((this.MainserviceService.lcaYear != "" && this.MainserviceService.state != "" && this.MainserviceService.city !="") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.postDate == "" && this.MainserviceService.lcaRole == ""))
    {
      this.getpostingdata20(this.MainserviceService.lcaYear, this.MainserviceService.state, this.MainserviceService.city);
    }          
    else if((this.MainserviceService.lcaYear != "" && this.MainserviceService.lcaRole != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.postDate == "" && this.MainserviceService.state == "" && this.MainserviceService.city ==""))
    {
      this.getpostingdata21(this.MainserviceService.lcaYear, this.MainserviceService.lcaRole);
    }      
    else if((this.MainserviceService.lcaYear != "" && this.MainserviceService.state != "" && this.MainserviceService.city !="" && this.MainserviceService.lcaRole != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.postDate == ""))
    {
      this.getpostingdata22(this.MainserviceService.lcaYear, this.MainserviceService.state, this.MainserviceService.city, this.MainserviceService.lcaRole);
    }          
    else if((this.MainserviceService.lcaYear != "" && this.MainserviceService.state != "" && this.MainserviceService.lcaRole != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.postDate == "" && this.MainserviceService.city ==""))
    {
      this.getpostingdata23(this.MainserviceService.lcaYear, this.MainserviceService.state, this.MainserviceService.lcaRole);
    }     
    else if((this.MainserviceService.state != "" && this.MainserviceService.lcaRole != "") && (this.MainserviceService.lcaNumber == "" && this.MainserviceService.postDate =="" && this.MainserviceService.lcaYear == "" && this.MainserviceService.city == ""))
    {
      this.getpostingdata24(this.MainserviceService.state, this.MainserviceService.lcaRole);
    }      
    else
    {
      this.getpostingdata();
    }

  }

  postingdata:any;
  filteredlca:any;
  getpostingdata()
  {
  //this.httpService.get('./assets/api/state.json').subscribe(
      this.MainserviceService.getpostdata().subscribe(
      data => {
        this.postingdata = data as string [];	 
       
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );
  }

  getpostingdata1(lcano)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(lcano!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCANumber==lcano){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }

  getpostingdata2(postDate)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(postDate!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }  

  getpostingdata3(state)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].stateId==state){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdata4(state,city)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(state!="" && city!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].stateId==state && this.filteredlca[i].city==city){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }  

  getpostingdata5(role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }

  getpostingdata6(lcayear)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(lcayear!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }

  getpostingdata7(lcano,postDate,lcayear,state,city,role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(lcano!="" && postDate!="" && lcayear!="" && state!="" && city!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCANumber==lcano && this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdata8(state,city,role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(state!="" && city!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].stateId==state && this.filteredlca[i].city==city && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }


  getpostingdata9(postDate, lcano)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcano!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCANumber==lcano){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }  

  getpostingdata10(postDate, lcayear)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcayear!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCAYear==lcayear){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }    

  getpostingdata11(postDate, role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdata12(postDate, state)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].stateId==state){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdata13(postDate, state, city)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && state!="" && city!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdata14(postDate, state, city, role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && state!="" && city!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdata15(postDate, lcayear, state, city, role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcayear!="" && state!="" && city!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdata16(postDate, lcayear, state)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcayear!="" && state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdata17(postDate, lcayear, state, city)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcayear!="" && state!="" && city!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdata18(postDate, lcayear, role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcayear!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }   

  getpostingdata19(lcayear, state)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(lcayear!="" && state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }   

  getpostingdata20(lcayear, state, city)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(lcayear!="" && state!="" && city!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdata21(lcayear, role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(lcayear!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }   

  getpostingdata22(lcayear, state, city, role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(lcayear!="" && state!="" && city!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdata23(lcayear, state, role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(lcayear!="" && state!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }   

  getpostingdata24(state,role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(state!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].stateId==state && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }
  
  
  ResetDataA()
  {
    this.clearData();    
    this.clearDataA();
    this.getstatename();
    this.getposition();    
  }
  postingsearchA(){

    var PostDate = moment(this.txtpostdateA.value).format("MM/DD/YYYY");

    if(PostDate == "Invalid date")
      this.MainserviceService.postDateA = "";
    else
      this.MainserviceService.postDateA = PostDate;

    if(this.txtlcanumA.value == null)
      this.MainserviceService.lcaNumberA = "";
    else
      this.MainserviceService.lcaNumberA = this.txtlcanumA.value;

    if(this.txtlcayearA.value == null)
      this.MainserviceService.lcaYearA = "";
    else
      this.MainserviceService.lcaYearA = this.txtlcayearA.value;

    if(this.selectStatearchive == undefined)
      this.MainserviceService.stateA = "";
    else
      this.MainserviceService.stateA = this.selectStatearchive;

    if(this.selectCityarchive == undefined)
      this.MainserviceService.cityA = "";
    else
      this.MainserviceService.cityA = this.selectCityarchive;

    if(this.selectRolearchive == undefined)
      this.MainserviceService.lcaRoleA = "";
    else
      this.MainserviceService.lcaRoleA = this.selectRolearchive;

    this.showtable= false;
    this.hidetable= false;
    this.archivedtable = false;
    this.hidearchivedtable=true;

    if((this.MainserviceService.lcaNumberA != "0" && this.MainserviceService.lcaNumberA != "") && (this.MainserviceService.postDateA == "" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.stateA =="" && this.MainserviceService.cityA == "" && this.MainserviceService.lcaRoleA ==""))
    {
      this.getpostingdataA1(this.MainserviceService.lcaNumberA);
    }
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.postDateA !="Invalid date") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.stateA =="" && this.MainserviceService.cityA == "" && this.MainserviceService.lcaRoleA ==""))
    {
      this.getpostingdataA2(this.MainserviceService.postDateA);
    }    
    else if((this.MainserviceService.stateA != "" && this.MainserviceService.stateA != null) && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.postDateA =="" && this.MainserviceService.cityA == "" && this.MainserviceService.lcaRoleA ==""))
    {
      this.getpostingdataA3(this.MainserviceService.stateA);
    }    
    else if((this.MainserviceService.stateA != ""  && this.MainserviceService.cityA != "" ) && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.postDateA =="" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.lcaRoleA == ""))
    {
      this.getpostingdataA4(this.MainserviceService.stateA, this.MainserviceService.cityA);
    }
    else if(this.MainserviceService.lcaRoleA != "" && (this.MainserviceService.lcaNumberA =="" && this.MainserviceService.postDateA == "" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.stateA =="" && this.MainserviceService.cityA == ""))
    {
      this.getpostingdataA5(this.MainserviceService.lcaRoleA);
    }
    else if(this.MainserviceService.lcaYearA != "" && (this.MainserviceService.lcaNumberA =="" && this.MainserviceService.postDateA == "" && this.MainserviceService.lcaRoleA == "" && this.MainserviceService.stateA =="" && this.MainserviceService.cityA == ""))
    {
      this.getpostingdataA6(this.MainserviceService.lcaYearA);
    }   
    else if(this.MainserviceService.lcaNumberA !="" && this.MainserviceService.postDateA != "" && this.MainserviceService.lcaRoleA != "" && this.MainserviceService.stateA !="" && this.MainserviceService.cityA != "" && this.MainserviceService.lcaYearA != "")
    {
      this.getpostingdataA7(this.MainserviceService.lcaNumberA,this.MainserviceService.postDateA,this.MainserviceService.lcaYearA,this.MainserviceService.stateA,this.MainserviceService.cityA,this.MainserviceService.lcaRoleA);
    }      
    else if((this.MainserviceService.stateA != ""  && this.MainserviceService.cityA != "" && this.MainserviceService.lcaRoleA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.postDateA =="" && this.MainserviceService.lcaYearA == ""))
    {
      this.getpostingdataA8(this.MainserviceService.stateA, this.MainserviceService.cityA,this.MainserviceService.lcaRoleA);
    }       
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.lcaNumberA != "") && (this.MainserviceService.lcaYearA == "" && this.MainserviceService.stateA == "" && this.MainserviceService.cityA =="" && this.MainserviceService.lcaRoleA == ""))
    {
      this.getpostingdataA9(this.MainserviceService.postDateA, this.MainserviceService.lcaNumberA);
    }   
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.lcaYearA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.stateA == "" && this.MainserviceService.cityA =="" && this.MainserviceService.lcaRoleA == ""))
    {
      this.getpostingdataA10(this.MainserviceService.postDateA, this.MainserviceService.lcaYearA);
    }   
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.lcaRoleA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.stateA == "" && this.MainserviceService.cityA ==""))
    {
      this.getpostingdataA11(this.MainserviceService.postDateA, this.MainserviceService.lcaRoleA);
    }     
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.stateA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.lcaRoleA == "" && this.MainserviceService.cityA ==""))
    {
      this.getpostingdataA12(this.MainserviceService.postDateA, this.MainserviceService.stateA);
    }       
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.stateA != "" && this.MainserviceService.cityA !="") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.lcaRoleA == ""))
    {
      this.getpostingdataA13(this.MainserviceService.postDateA, this.MainserviceService.stateA, this.MainserviceService.cityA);
    }    
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.stateA != "" && this.MainserviceService.cityA !="" && this.MainserviceService.lcaRoleA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.lcaYearA == ""))
    {
      this.getpostingdataA14(this.MainserviceService.postDateA, this.MainserviceService.stateA, this.MainserviceService.cityA, this.MainserviceService.lcaRoleA);
    }                
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.lcaYearA != "" && this.MainserviceService.stateA != "" && this.MainserviceService.cityA !="" && this.MainserviceService.lcaRoleA != "") && (this.MainserviceService.lcaNumberA == ""))
    {
      this.getpostingdataA15(this.MainserviceService.postDateA, this.MainserviceService.lcaYearA, this.MainserviceService.stateA, this.MainserviceService.cityA, this.MainserviceService.lcaRoleA);
    }   
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.lcaYearA != "" && this.MainserviceService.stateA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.cityA =="" && this.MainserviceService.lcaRoleA == ""))
    {
      this.getpostingdataA16(this.MainserviceService.postDateA, this.MainserviceService.lcaYearA, this.MainserviceService.stateA);
    }   
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.lcaYearA != "" && this.MainserviceService.stateA != "" && this.MainserviceService.cityA !="") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.lcaRoleA == ""))
    {
      this.getpostingdataA17(this.MainserviceService.postDateA, this.MainserviceService.lcaYearA, this.MainserviceService.stateA, this.MainserviceService.cityA);
    }   
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.lcaYearA != "" && this.MainserviceService.lcaRoleA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.stateA == "" && this.MainserviceService.cityA ==""))
    {
      this.getpostingdataA18(this.MainserviceService.postDateA, this.MainserviceService.lcaYearA, this.MainserviceService.lcaRoleA);
    }               
    else if((this.MainserviceService.lcaYearA != "" && this.MainserviceService.stateA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.postDateA == "" && this.MainserviceService.cityA =="" && this.MainserviceService.lcaRoleA == ""))
    {
      this.getpostingdataA19(this.MainserviceService.lcaYearA, this.MainserviceService.stateA);
    }  
    else if((this.MainserviceService.lcaYearA != "" && this.MainserviceService.stateA != "" && this.MainserviceService.cityA !="") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.postDateA == "" && this.MainserviceService.lcaRoleA == ""))
    {
      this.getpostingdataA20(this.MainserviceService.lcaYearA, this.MainserviceService.stateA, this.MainserviceService.cityA);
    }          
    else if((this.MainserviceService.lcaYearA != "" && this.MainserviceService.lcaRoleA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.postDateA == "" && this.MainserviceService.stateA == "" && this.MainserviceService.cityA ==""))
    {
      this.getpostingdataA21(this.MainserviceService.lcaYearA, this.MainserviceService.lcaRoleA);
    }      
    else if((this.MainserviceService.lcaYearA != "" && this.MainserviceService.stateA != "" && this.MainserviceService.cityA !="" && this.MainserviceService.lcaRoleA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.postDateA == ""))
    {
      this.getpostingdataA22(this.MainserviceService.lcaYearA, this.MainserviceService.stateA, this.MainserviceService.cityA, this.MainserviceService.lcaRoleA);
    }     
    else if((this.MainserviceService.lcaYearA != "" && this.MainserviceService.stateA != "" && this.MainserviceService.lcaRoleA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.postDateA == "" && this.MainserviceService.cityA ==""))
    {
      this.getpostingdataA23(this.MainserviceService.lcaYearA, this.MainserviceService.stateA, this.MainserviceService.lcaRoleA);
    }            
    else if((this.MainserviceService.stateA != ""  && this.MainserviceService.lcaRoleA != "") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.postDateA =="" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.cityA == ""))
    {
      this.getpostingdataA24(this.MainserviceService.stateA, this.MainserviceService.lcaRoleA);
    }           
    else
    {
      this.getpostingdataA();
    }

  }


  archiveddata:any;
  getpostingdataA()
  {
  //this.httpService.get('./assets/api/state.json').subscribe(
        this.MainserviceService.getarchivedata().subscribe(
      data => {
        this.archiveddata = data as string [];	 
       
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );
  }

  getpostingdataA1(lcano)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(lcano!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCANumber==lcano){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }

  getpostingdataA2(postDate)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }  

  getpostingdataA3(state)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].stateId==state){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }  

  getpostingdataA4(state,city)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].stateId==state && this.filteredlca[i].city==city){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }  

  getpostingdataA5(role)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }

  getpostingdataA6(lcayear)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(lcayear!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }

  getpostingdataA7(lcano,postdt,lcayear,state,city,role)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCANumber==lcano && this.filteredlca[i].PostedOnDate==postdt && this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdataA8(state,city,role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].stateId==state && this.filteredlca[i].city==city && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }


  getpostingdataA9(postDate, lcano)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcano!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCANumber==lcano){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }  

  getpostingdataA10(postDate, lcayear)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcayear!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCAYear==lcayear){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }    

  getpostingdataA11(postDate, role)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdataA12(postDate, state)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].stateId==state){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdataA13(postDate, state, city)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && state!="" && city!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdataA14(postDate, state, city, role)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && state!="" && city!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdataA15(postDate, lcayear, state, city, role)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcayear!="" && state!="" && city!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdataA16(postDate, lcayear, state)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcayear!="" && state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdataA17(postDate, lcayear, state, city)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcayear!="" && state!="" && city!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdataA18(postDate, lcayear, role)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!="" && lcayear!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate && this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }   

  getpostingdataA19(lcayear, state)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(lcayear!="" && state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }   

  getpostingdataA20(lcayear, state, city)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(lcayear!="" && state!="" && city!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 

  getpostingdataA21(lcayear, role)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(lcayear!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }   

  getpostingdataA22(lcayear, state, city, role)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(lcayear!="" && state!="" && city!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }   

  getpostingdataA23(lcayear, state, role)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(lcayear!="" && state!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }   

  getpostingdataA24(state,role)
  {
    this.MainserviceService.getpostdata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.postingdata=[];    
          var len=this.filteredlca.length;
            if(state!="" && role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].stateId==state && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.postingdata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }  

  clearData()
  {
    this.showtable= true;
    this.hidetable= false;
    this.archivedtable = false;
    this.hidearchivedtable=false;
       
    this.MainserviceService.postDate = "";
    this.MainserviceService.lcaNumber = "";
    this.MainserviceService.lcaYear = "";
    this.MainserviceService.state = "";
    this.MainserviceService.city = "";
    this.MainserviceService.lcaRole = "";

    this.txtpostdate.reset();
    this.txtlcanum.reset();
    this.txtlcayear.reset();
    this.selState.reset();
    this.selCity.reset();
    this.selRole.reset();
  }
 
  clearDataA()
  {
    this.showtable= false;
    this.hidetable= false;
    this.archivedtable = true;
    this.hidearchivedtable=false;

    this.MainserviceService.postDateA = "";
    this.MainserviceService.lcaNumberA = "";
    this.MainserviceService.lcaYearA = "";
    this.MainserviceService.stateA = "";
    this.MainserviceService.cityA = "";
    this.MainserviceService.lcaRoleA = "";

    this.txtpostdateA.reset();
    this.txtlcanumA.reset();
    this.txtlcayearA.reset();
    this.selStateA.reset();
    this.selCityA.reset();
    this.selRoleA.reset();
  }

  getstatename()
  {
    this.MainserviceService.getstate().subscribe(
      data => {
        this.statelist = data as string [];       
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );
    
  }

  getposition()
  {
    this.MainserviceService.getposition().subscribe(
      data => {
        this.positionlist = data as string [];	        
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );
  }

  changeArchive()
  {
    this.showtable= false;
    this.hidetable= false;
    this.archivedtable = true;
  }
 
  onChange(event: MatTabChangeEvent) {
    const tab = event.tab.textLabel;
    //console.log(tab);
    if(tab==="Search posting")
     {
       this.showtable= true;
       this.hidetable= false;
       this.archivedtable = false;
       this.hidearchivedtable=false;
     }    
    if(tab==="Archived posting")
     {
       this.showtable= false;
       this.hidetable= false;
       this.archivedtable = true;
       this.hidearchivedtable=false;
     }
  }

  selectState: null;
  selectStateDesc: null;
  selectCity: null;
  selectRole:null; 
  selectRoleDesc:null; 
  selectStatearchive: null;
  selectStatearchiveDesc: null;
  selectCityarchive: null;
  selectRolearchive:null; 
  selectRolearchiveDesc:null; 
  
  changeState(val){

    this.selectState = val;
       this.MainserviceService.getcities().subscribe(     
      data => {
        this.cities = data as string [];	 
        this.filteredcities=[];    
          var len=this.cities.length;
            if(this.selectState!=""){
            for (let i = 0; i < len; i++) {
              if(this.cities[i].StateCode==this.selectState){
              let obj = {
                City: this.cities[i].CityName,         
              };
              this.filteredcities.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    ); 
     this.statelist.filter(data => {
       debugger;
        if (this.selectState === data.StateID) {
          this.selectStateDesc = data.StateName;
        }
      }); 
    
  }

  changeStateA(val){

    this.selectStatearchive = val;
    this.MainserviceService.getcities().subscribe(     
      data => {
          this.citiesarchive = data as string [];	 
          this.filteredcitiesarchive=[];    
          var len=this.citiesarchive.length;
          if(this.selectStatearchive!=""){
            for (let i = 0; i < len; i++) {
              if(this.citiesarchive[i].StateCode==this.selectStatearchive){
              let obj = {
                City: this.citiesarchive[i].CityName,
                CityCode:this.citiesarchive[i].CityID,
              };
              this.filteredcitiesarchive.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );  
     this.statelist.filter(data => {       
        if (this.selectStatearchive === data.StateID) {
          this.selectStatearchiveDesc = data.StateName;
        }
      }); 
  }
  
  changeCity(val){
    this.selectCity = val;
  }

  changeRole(val){
    this.selectRole = val;
    this.positionlist.filter(data => {       
        if (this.selectRole === data.LCAroleId) {
          this.selectRoleDesc = data.LCAroleName;
        }
      }); 
  }

  changeCityA(val){
    this.selectCityarchive = val;
  }

  changeRoleA(val){
    this.selectRolearchive = val;
    this.positionlist.filter(data => {       
        if (this.selectRolearchive === data.LCAroleId) {
          this.selectRolearchiveDesc = data.LCAroleName;
        }
      }); 
  }

}

